import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "@/app/config/routes";
import { MainLayout } from "@/app/layouts/MainLayout";
import { AuthGuard } from "@/app/components/AuthGuard";
import { UploadPage } from "@/app/pages/UploadPage";
import { AppsPage } from "@/app/pages/AppsPage";
import { AppDetailPage } from "@/app/pages/AppDetailPage";
import { ConfirmPage } from "@/app/pages/ConfirmPage";
import { PlansPage } from "@/app/pages/PlansPage";
import { LoginPage } from "@/app/pages/LoginPage";
import { useAuth } from "@/app/contexts/AuthContext";

function GuardedShell() {
  return (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  );
}

function LoginShell() {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return <Navigate to={ROUTES.upload} replace />;
  }
  return <LoginPage />;
}

export const router = createBrowserRouter([
  { path: ROUTES.login, element: <LoginShell /> },

  {
    element: <GuardedShell />,
    children: [
      {
        element: <MainLayout />,
        children: [
          { path: ROUTES.upload, element: <UploadPage /> },
          { path: ROUTES.apps, element: <AppsPage /> },
          { path: "/apps/:appId", element: <AppDetailPage /> },
          { path: ROUTES.confirm, element: <ConfirmPage /> },
          { path: ROUTES.plans, element: <PlansPage /> },
        ],
      },
    ],
  },

  { path: "/", element: <Navigate to={ROUTES.upload} replace /> },
  { path: "*", element: <Navigate to={ROUTES.upload} replace /> },
]);
